import { useEffect, useState, useRef } from "react";
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";

function Terms() {
  const [content, setContent] = useState("");
  const contentRef = useRef(null);

  useEffect(() => {
    fetch("/terms.html")
      .then((res) => res.text())
      .then((data) => setContent(data))
      .catch((err) => console.error("Failed to load terms.html:", err));
  }, []);

  // Initialize sidebar functionality after content loads
  useEffect(() => {
    if (!contentRef.current) return;

    const menuItems = contentRef.current.querySelectorAll(".terms-sidebar li");
    const sections = contentRef.current.querySelectorAll("section");
    const leftSidebar = contentRef.current.querySelector("#leftSidebar");
    const contentArea = contentRef.current.querySelector(".terms-content");


    if (!menuItems.length || !sections.length) return;

    // Click to scroll
    menuItems.forEach((item) => {
      item.addEventListener("click", () => {
        const targetId = item.getAttribute("data-target");
        const targetSection = contentRef.current.querySelector(`#${targetId}`);
        if (targetSection) {
          targetSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    });

    // Intersection Observer for active menu
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            menuItems.forEach((i) => i.classList.remove("active"));

            const activeItem = contentRef.current.querySelector(
              `[data-target="${entry.target.id}"]`
            );
            if (activeItem) {
              activeItem.classList.add("active");

              // Auto-scroll sidebar if needed
              if (leftSidebar) {
                const offset = activeItem.offsetTop - 100;
                leftSidebar.scrollTo({ top: offset, behavior: "smooth" });
              }
            }
          }
        });
      },
      { root: contentArea, threshold: 0.35 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, [content]);

  return (
    <>
      <div
        style={{
          background: "#000",
          minHeight: "100vh",
           padding: "60px 0",
        }}
      >
        <Navbar />
        <div
          ref={contentRef}
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      

      <Footer />
      </div>
    </>
  );
}

export default Terms;